module.exports = __webpack_public_path__ + "static/media/writing.9a7a33cc.jpg";